import { ChatLinkPolicy } from '@core/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { joinWebinar, leaveWebinar } from './live-webinar-slice';
import { onDemandJoinWebinar, onDemandLeaveWebinar } from './on-demand-webinar-slice';

export interface ChatLinkPolicyState {
    allowedDomains: string[];
    blockedDomains: string[];
    selfHost: string;
}

// Until the hub delivers the policy every link is "unknown" and warns before opening — the safe default.
const initialState: ChatLinkPolicyState = {
    allowedDomains: [],
    blockedDomains: [],
    selfHost: ''
};

export const chatLinkPolicySlice = createSlice({
    name: 'chatLinkPolicy',
    initialState,
    reducers: {
        chatLinkPolicyReceived: (state, action: PayloadAction<ChatLinkPolicy>) => {
            state.allowedDomains = action.payload.allowedDomains;
            state.blockedDomains = action.payload.blockedDomains;
            state.selfHost = action.payload.selfHost;
        }
    },
    // The hub re-sends the policy on every connect, so joining/leaving a webinar can drop it safely.
    extraReducers: (builder) => {
        builder
            .addCase(joinWebinar, () => initialState)
            .addCase(leaveWebinar, () => initialState)
            .addCase(onDemandJoinWebinar, () => initialState)
            .addCase(onDemandLeaveWebinar, () => initialState);
    }
});

export const { chatLinkPolicyReceived } = chatLinkPolicySlice.actions;

export default chatLinkPolicySlice.reducer;
